import { render, staticRenderFns } from "./WidgetItem.vue?vue&type=template&id=0d6aaf2f&"
import script from "./WidgetItem.vue?vue&type=script&lang=js&"
export * from "./WidgetItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports